    <div class="bb-transactions-list-filter">
      <form
        class="card-body"
        [formGroup]="hostRef.transactionsFilterForm"
        (ngSubmit)="hostRef.onFilter(hostRef.transactionsFilterForm.value)"
        autocomplete="off"
        >
        <div class="bb-block bb-block--sm">
          <div class="row">
            <!-- Date range -->
            <div class="col-lg-7">
              <div class="bb-stack" formGroupName="date">
                <div class="col-12 col-sm-6">
                  <div class="form-group">
                    <bb-input-datepicker-ui
                      name="dateRange"
                      label="From date"
                      i18n-label="Transaction filter for the From Date Range@@transactions.filter.form.label.fromDate"
                      formControlName="from"
                      placeholder="MM/DD/YYYY"
                      [maxDate]="hostRef.formatDateToString(hostRef.transactionsFilterForm.controls['date'].value.to)"
                    ></bb-input-datepicker-ui>
                  </div>
                </div>

                <div class="col-12 col-sm-6">
                  <div class="form-group">
                    <bb-input-datepicker-ui
                      name="dateRange"
                      label="To date"
                      i18n-label="Transaction filter for the to Date Range@@transactions.filter.form.label.toDate"
                      formControlName="to"
                      placeholder="MM/DD/YYYY"
                      [minDate]="hostRef.formatDateToString(hostRef.fromDate?.value)"
                    ></bb-input-datepicker-ui>
                  </div>
                </div>
              </div>
            </div>
            <!-- Amount range -->
            <div class="col-lg-5 " bbDynamicId #amountGroup>
              <div class="bb-stack" formGroupName="amount">
                <div class="bb-stack__item bb-transactions-list-filter__field">
                  <label bbDynamicId #fromAmountLabel
                         i18n="From amount|From amount filters@@transactions.filter.form.amountFrom">
                    From amount
                  </label>

                  <!-- <bb-amount-input-ui formControlName="from"
                                      data-role="amountFrom"
                                      placeholder="From"
                                      i18n-placeholder="Initial filtering value|Starting value|Lower amount@@transactions.filter.form.placeholder.amountFrom"
                                      [autoDecimal]="true"
                                      [aria-describedby]="'compact-amount-error-message-1'">
                  </bb-amount-input-ui> -->
                  <input 
                    formControlName="from" 
                    class="form-control" 
                    type="text" 
                    step="any" 
                    placeholder="From"
                    bnAutoDecimal
                    i18n-placeholder="Initial filtering value|Starting value|Lower amount@@transactions.filter.form.placeholder.amountFrom" 
                  />
                </div>

                <div class="bb-stack__item bb-transactions-list-filter__field">
                  <label bbDynamicId #toAmountLabel
                         i18n="From amount|From amount filters@@transactions.filter.form.amountTo">
                    To amount
                  </label>
                  <input 
                    formControlName="to" 
                    class="form-control" 
                    type="text" 
                    step="any" 
                    placeholder="To"
                    bnAutoDecimal
                    i18n-placeholder="Ending filtering value|End value|Higher amount@@transactions.filter.form.placeholder.amountTo"
                  />
                </div>
              </div>
              <bb-input-validation-message-ui
                [showErrors]="!hostRef.isFieldValid('amount', 'from') || !hostRef.isFieldValid('amount', 'to')"
                messageId="{{amountGroup?.id}}-error"
              >
                <span i18n="Max. amount cannot be smaller than the min. amount|Error Message when max amount is smaller than min amount@@transactions.filter.form.error.amountRange">
                  Maximum amount cannot be smaller than the minimum amount
                </span>
              </bb-input-validation-message-ui>
            </div>
          </div>


          <div class="row">
            <!-- Check range -->
            <div class="form-group">
              <div class="col-lg-12 bb-stack" formGroupName="checkSerialNumber" bbDynamicId #rangeGroup>
                <div class="col-12 col-sm-5 bb-stack__item bb-transactions-list-filter__field">
                  <label bbDynamicId #fromCheckLabel
                    i18n="From check number|From check number@@transactions.filter.form.fromCheckNumber">
                    From check number
                  </label>
                  <bb-input-number-ui
                    [aria-labelledby]="fromCheckLabel?.id"
                    formControlName="from"
                    placeholder="From"
                    i18n-placeholder="'From' number range input@@transactions.filter.form.placeholder.rangeFrom"
                    aria-describedby="{{rangeGroup?.id}}-error"
                    min="0"
                  ></bb-input-number-ui>
                </div>
                <div class="col-12 col-sm-5 bb-stack__item bb-transactions-list-filter__field">
                  <label bbDynamicId #toCheckLabel
                  i18n="From check number|From check number@@transactions.filter.form.toCheckNumber">
                    To check number
                  </label>
                  <bb-input-number-ui
                    [aria-labelledby]="toCheckLabel?.id"
                    formControlName="to"
                    placeholder="To"
                    i18n-placeholder="'To' number range input@@transactions.filter.form.placeholder.rangeTo"
                    aria-describedby="{{rangeGroup?.id}}-error"
                    min="0"
                  ></bb-input-number-ui>
                </div>
              </div>
              <bb-input-validation-message-ui
                [showErrors]="!hostRef.isFieldValid('checkSerialNumber', 'from') || !hostRef.isFieldValid('checkSerialNumber', 'to')"
                messageId="{{rangeGroup?.id}}-error"
              >
                <span i18n="Last check nº cannot be smaller than first check nº|Error Message when last check nº is smaller than first check nº@@transactions.filter.form.error.checkSerialRange">
                  Last check number cannot be smaller than first check number
                </span>
              </bb-input-validation-message-ui>
            </div>
          </div>
        </div>

        <div class="bb-button-bar ">
          <!-- Apply -->
          <button
            bbButton
            type="submit"
            color="primary"
            class="bb-button-bar__button"
            data-role="apply"
            i18n-title="Apply button|Apply selected filters@@transactions.filter.form.button.apply"
            title="Apply"
            i18n="Apply button|Apply selected filters@@transactions.filter.form.button.apply"
            [disabled]="hostRef.transactionsFilterForm.invalid || !hostRef.transactionsFilterForm.dirty"
          >
            Apply
          </button>

          <!-- Close -->
          <button
            bbButton
            type="button"
            color="secondary"
            class="bb-button-bar__button"
            data-role="cancel"
            i18n-title="Close button|Close filter menu@@transactions.filter.form.button.close"
            title="Close"
            i18n="Close button|Close filter menu@@transactions.filter.form.button.close"
            (click)="hostRef.onCloseFilter()"
          >
            Cancel
          </button>

          <!-- Clear filters -->
          <button
            bbButton
            type="button"
            color="link"
            class="bb-button-bar__button btn-md btn"
            data-role="clear-all"
            i18n-title="Clear Filters button|Clean filters@@transactions.filter.form.button.clearAll"
            title="Clear"
            (click)="hostRef.onClearFilter()"
            [disabled]="!hostRef.transactionsFilterForm.dirty"
            i18n="Clear filters button|Clean filters@@transactions.filter.form.button.clearAll"
          >
            Clear all
          </button>
        </div>
      </form>
    </div>
